import { createBrowserRouter, Navigate } from 'react-router-dom';

import { AppLayout } from '@/components/layout/app-layout';
import { AcceptInvitePage } from '@/pages/auth/accept-invite';
import { ForgotPasswordPage } from '@/pages/auth/forgot-password';
import { LoginPage } from '@/pages/auth/login';
import { ResetPasswordPage } from '@/pages/auth/reset-password';
import { SignupPage } from '@/pages/auth/signup';
import { VerifyEmailPage } from '@/pages/auth/verify-email';
import { CampaignDetailPage, CampaignsListPage } from '@/pages/app/campaigns';
import { DashboardPage } from '@/pages/app/dashboard';
import { LeadListDetailPage } from '@/pages/app/lead-list';
import { LeadsPage } from '@/pages/app/leads';
import { MailboxesPage } from '@/pages/app/mailboxes';
import { RepliesPage } from '@/pages/app/replies';
import { SentPage } from '@/pages/app/sent';
import { SettingsPage } from '@/pages/app/settings';
import { LandingPage } from '@/pages/landing';

import { NotFound } from './not-found';
import { RootError } from './root-error';

export const router = createBrowserRouter([
  { path: '/', element: <LandingPage />, errorElement: <RootError /> },

  // Auth flow (unauthenticated).
  { path: '/login', element: <LoginPage />, errorElement: <RootError /> },
  { path: '/signup', element: <SignupPage />, errorElement: <RootError /> },
  { path: '/verify-email', element: <VerifyEmailPage />, errorElement: <RootError /> },
  { path: '/forgot-password', element: <ForgotPasswordPage />, errorElement: <RootError /> },
  { path: '/reset-password/:token', element: <ResetPasswordPage />, errorElement: <RootError /> },
  { path: '/accept-invite/:token', element: <AcceptInvitePage />, errorElement: <RootError /> },

  // Authenticated shell.
  {
    element: <AppLayout />,
    errorElement: <RootError />,
    children: [
      { path: '/dashboard', element: <DashboardPage /> },
      { path: '/campaigns', element: <CampaignsListPage /> },
      { path: '/campaigns/:id', element: <CampaignDetailPage /> },
      { path: '/mailboxes', element: <MailboxesPage /> },
      // Old path — keep working for bookmarks and any in-flight OAuth
      // callbacks issued before this rename shipped.
      { path: '/inboxes', element: <Navigate to="/mailboxes" replace /> },
      { path: '/leads', element: <LeadsPage /> },
      { path: '/leads/:listId', element: <LeadListDetailPage /> },
      { path: '/replies', element: <RepliesPage /> },
      { path: '/sent', element: <SentPage /> },
      // Analytics is a first-class page in the flow diagram — for now
      // it lives on the dashboard summary. Add a dedicated view later.
      { path: '/analytics', element: <Navigate to="/dashboard" replace /> },
      { path: '/settings', element: <SettingsPage /> },
    ],
  },

  { path: '*', element: <NotFound /> },
]);
